import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { SearchProvider } from "./shared/contexts/SearchContext";
import { ZoomWrapper } from "./shared/components/ZoomWrapper/ZoomWrapper";
import { CalendarProvider } from "./shared/contexts/CalendarContext";
import { GeneralProvider } from "./shared/contexts/GeneralContext";
import { initSentry } from "./shared/config/sentry";
import { AuthProvider } from "./shared/contexts/AuthContext";
import { GTM } from "./Components/atoms/GTM/GTM";
import { rememberCampaignVisit } from "./shared/utils/campaignVisit";

initSentry();
rememberCampaignVisit(window.location.search);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <GTM />
      <BrowserRouter>
        <AuthProvider>
          <GeneralProvider>
            <SearchProvider>
              <CalendarProvider>
                <ZoomWrapper>
                  <App />
                </ZoomWrapper>
              </CalendarProvider>
            </SearchProvider>
          </GeneralProvider>
        </AuthProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
